export const FILE_API_PATH:  string = '/api/files/';
export const DOWNLOAD_API_PATH:  string = '/api/download/';
